export const Themes = {
  DEFAULT: 'default',
  TOL: 'tol' //Journalist Support
};

export const getTheme = () => {
  const applicationDiv = document.querySelector('#application-div');

  if (!applicationDiv) {
    return Themes.DEFAULT;
  }

  const spotId = applicationDiv.getAttribute('data-spotid');

  if (
    spotId === 'sp_iQ9uXDsX' ||
    spotId === 'sp_nNNHCgsN' ||
    spotId === 'sp_pCQgrRiN' ||
    spotId === 'sp_ci83vMEV' ||
    spotId === 'sp_GKIX93PW' ||
    spotId === 'sp_31F4ZGB4' ||
    spotId === 'sp_HgoPVEje' ||
    spotId === 'sp_sZl4kdDA' ||
    spotId === 'sp_Hmnwda3Z' ||
    spotId === 'sp_hTdJATT5' ||
    //The Sun spots
    spotId === 'sp_pktx554P' ||
    spotId === 'sp_fxIRLxxB' ||
    spotId === 'sp_5v3VPY0c' ||
    spotId === 'sp_Y5f0Pdpw' ||
    spotId === 'sp_Yzh1BEWu' ||
    spotId === 'sp_kebMnZvt' ||
    spotId === 'sp_1Hoidssy'
  ) {
    return Themes.TOL;
  }

  return Themes.DEFAULT;
};

export const isTOL = () => getTheme() === Themes.TOL;
